module.exports = __webpack_public_path__ + "static/media/4.b96d6556.png";